const PING_VESSEL_VOYAGE_INFO_URL = `${process.env.REACT_APP_PING_ORIGIN_URL}/ping-admin/vessel-voyage-info`

const PingVesselVoyageInfoUrls = {
    GET: `${PING_VESSEL_VOYAGE_INFO_URL}/get`
}

export default PingVesselVoyageInfoUrls
